import React from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import OSTotaisGrid from "../../../components/OSTotaisGrid";
import {useSelector} from "react-redux";
import MiniPieChart from "./MiniPieChart";
import {ListItem, Typography} from "@material-ui/core";
import List from "@material-ui/core/List";


const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        //backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        width: '120px',
        alignItems: 'center'


    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexWrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center'
       // alignSelf: 'stretch',
    },
    operadores: {
        display: 'flex',
        flexDirection:'column',
        flexWrap: 'wrap',
        flexGrow: 12
    },

    gridOSTotais: {
        display: 'flex',
        flexDirection:'column',
        flexWrap: 'nowrap',
        flexGrow: 3,
        justifyContent: 'center',

        margin: 0,
        padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        marginBottom:'30px',
        // width: '120px'

    },
    gridChart: {
      display: 'flex',
        flexDirection: 'row',
      justifyContent: 'center',
        flexWrap: 'wrap'
    },
    operadoresGrid: {
        alignContent: 'flex-start',
        alignSelf: 'flex-start'
    }



}));

const ProducaoMensalBandasView = () => {

    const classes= useStyles();
    const listaOSs = useSelector( state => state.i4.listaOSs);
    const pneuBandas = useSelector( state => state.serviceOrderStatistics.tireStatistics.tireBands )



    let bandasAplicadas = [];
    let bandasTipoAplicadas = []
    listaOSs
        .filter( os => os.processoId === 1)
        .map( (os,i) => {
            const ix = bandasAplicadas.findIndex( b => b.id === os.itemIdBandaAplicada);
            if (ix < 0) {
                bandasAplicadas.push({
                    id: os.itemIdBandaAplicada,
                    banda: os.itemBandaAplicada ? os.itemBandaAplicada : 'NAO ESPEC.',
                    quantidade: 1
                })
            } else {
                bandasAplicadas[ix].quantidade += 1;
            }
        const grpDesc = os.grupoMaterialUnique? os.grupoMaterialUnique : 'NAO ESPEC.'
        const ixt = bandasTipoAplicadas.findIndex( b => b.descricao === grpDesc);
        if (ixt < 0) {
            bandasTipoAplicadas.push({
                id: os.itemIdBandaAplicada,
                descricao: grpDesc,
                quantidade: 1
            })
        } else {
            bandasTipoAplicadas[ixt].quantidade += 1;
        }


    })




        return (
            <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid item container xs={12} sm={12} lg={12} xl={12}>
                            <Grid item container className={classes.gridOSTotais} style={{ alignContent: 'stretch', justifyContent: 'stretch'  }} xs={3} sm={3} md={4} lg={4} xl={4}>
                            <Grid item container className={classes.gridChart}>
                                <Typography gutterBottom variant="h5" style={{height: '60px'}}>BANDAS SOLICITADAS</Typography>
                            </Grid>
                            <Grid item container className={classes.gridChart}>
                                <MiniPieChart data={pneuBandas} dataKey="total" nameKey="banda" />
                            </Grid>
                            <Grid id="gridTabPneuBandas" item container className={classes.gridChart}  xs={12} sm={12} md={12} lg={12} xl={12}>
                                <List style={{display:'flex', flexDirection:'column', width:'50%', justifyContent:'flex-start'}}>
                                {
                                    pneuBandas
                                        .sort(function(a, b) {
                                            if (!a.total) { return 0; }
                                            if (a.total < b.total) { return 1; }
                                            if (a.total > b.total) { return -1; }
                                            return 0;
                                        })
                                        .slice(0,8)
                                        .map( (b,ix) => {
                                        return (
                                            <ListItem key={ix} style={{display:'flex', justifyContent:'space-between'}}>
                                                <Typography>{b.banda}</Typography>
                                                <Typography>{b.total}</Typography>
                                            </ListItem>
                                        )
                                    })
                                }
                                </List>
                            </Grid>
                        </Grid>

                        <Grid item container className={classes.gridOSTotais} style={{ alignContent: 'stretch',  justifyContent: 'stretch'  }} xs={3} sm={4} md={3} lg={4} xl={4}>
                            <Grid item container className={classes.gridChart}>
                                <Typography gutterBottom variant="h5" style={{height: '60px'}}> BANDAS APLICADAS</Typography>
                            </Grid>
                            <Grid item container className={classes.gridChart}>
                                    <MiniPieChart data={bandasAplicadas} dataKey="quantidade" nameKey="banda" />
                            </Grid>
                            <Grid id="gridTabbandasAplicadas" item container className={classes.gridChart}  xs={12} sm={12} md={12} lg={12} xl={12}>
                                <List style={{display:'flex', flexDirection:'column', width:'80%', justifyContent:'flex-start'}}>
                                    {
                                        bandasAplicadas
                                            .sort(function(a, b) {
                                                if (!a.quantidade) { return 0; }
                                                if (a.quantidade < b.quantidade) { return 1; }
                                                if (a.quantidade > b.quantidade) { return -1; }
                                                return 0;
                                            })
                                            .slice(0,8)
                                            .map( (b,ix) => {
                                                return (
                                                    <ListItem key={ix} style={{display:'flex', justifyContent:'space-between'}}>
                                                        <Typography>{b.banda}</Typography>
                                                        <Typography>{b.quantidade}</Typography>
                                                    </ListItem>
                                                )
                                            })
                                    }
                                </List>
                            </Grid>
                        </Grid>

                        <Grid item container className={classes.gridOSTotais} style={{ alignContent: 'stretch', justifyContent: 'stretch'  }} xs={3} sm={4} md={3} lg={4} xl={4}>
                            <Grid item container className={classes.gridChart}>
                                <Typography gutterBottom variant="h5" style={{height: '60px'}} >GRUPOS DE BANDAS</Typography>
                            </Grid>
                            <Grid item container className={classes.gridChart} >
                                <MiniPieChart data={bandasTipoAplicadas} dataKey="quantidade" nameKey="descricao" />
                            </Grid>
                            <Grid id="gridTabbandasAplicadas" item container className={classes.gridChart} xs={12} sm={12} md={12} lg={12} xl={12}>
                                <List style={{display:'flex', flexDirection:'column', width:'50%', justifyContent:'flex-start'}}>
                                    {
                                        bandasTipoAplicadas
                                            .sort(function(a, b) {
                                                if (!a.quantidade) { return 0; }
                                                if (a.quantidade < b.quantidade) { return 1; }
                                                if (a.quantidade > b.quantidade) { return -1; }
                                                return 0;
                                            })
                                            .slice(0,8)
                                            .map( (b,ix) => {
                                                return (
                                                    <ListItem key={ix} style={{display:'flex', justifyContent:'space-between'}}>
                                                        <Typography>{b.descricao}</Typography>
                                                        <Typography>{b.quantidade}</Typography>
                                                    </ListItem>
                                                )
                                            })
                                    }
                                </List>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        )
    }

export default (ProducaoMensalBandasView);


